export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      excursions: 'Excursiones',
      fleet: 'Vehículos',
      reserve: 'Reservar',
      admin: 'Admin',
    },
    hero: {
      tag: 'Tu Transporte en República Dominicana',
      title1: 'Muévete sin preocupaciones',
      title2: 'en República Dominicana',
      subtitle: 'Olvídate de esperar o negociar. Con nuestro transporte privado tienes puntualidad, seguridad y comodidad garantizada desde el primer minuto. Traslados al aeropuerto, hoteles y viajes personalizados con servicio de primera.',
      pickup: 'Recogida (Aeropuerto u Hotel)',
      pickupPh: 'Buscar aeropuerto u hotel...',
      destination: 'Destino',
      destinationPh: 'Buscar destino...',
      date: 'Fecha',
      passengers: 'Pasajeros',
      passengersWord: 'Pasajeros',
      passengerWord: 'Pasajero',
      cta: 'Ver Disponibilidad',
      stat1: 'Disponible',
      stat2: 'Choferes Licenciados',
      stat3: 'Mejor Calificados',
    },
    services: {
      tag: 'Qué Ofrecemos',
      title: 'Nuestros Servicios',
      subtitle: 'Desde recogidas en el aeropuerto hasta traslados VIP exclusivos, ofrecemos soluciones de transporte integrales en República Dominicana.',
      seeMore: 'Ver Más',
      items: [
        { title: 'Traslados al Aeropuerto', desc: 'Recogida y entrega confiable desde el Aeropuerto Internacional de Punta Cana a cualquier hotel o destino.' },
        { title: 'Transporte Privado', desc: 'Viajes privados exclusivos para parejas, familias o viajeros solos con servicio personalizado.' },
        { title: 'Transporte Grupal', desc: 'Vehículos cómodos para grupos de cualquier tamaño, perfectos para eventos y reuniones.' },
        { title: 'Transporte a Excursiones', desc: 'Transporte a excursiones populares como Isla Saona, Santo Domingo y más.' },
        { title: 'Servicio VIP', desc: 'Vehículos premium con comodidades de lujo para los viajeros más exigentes.' },
        { title: 'Traslados entre Ciudades', desc: 'Transporte interurbano en República Dominicana con comodidad y seguridad.' },
      ],
    },
    map: {
      tag: 'Cobertura de Servicio',
      title: 'Nuestros Destinos',
      subtitle: 'Cubrimos toda la República Dominicana. Selecciona un aeropuerto para ver rutas y precios.',
      airports: 'Aeropuertos',
      destinations: 'Destinos',
    },
    excursions: {
      tag: 'Explora el Paraíso',
      title: 'Excursiones Populares',
      subtitle: 'Descubre los destinos más hermosos de República Dominicana con nuestro transporte cómodo.',
      reserve: 'Reservar Excursión',
      viewAll: 'Ver Todas las Excursiones',
      groups: 'Todos los grupos',
    },
    fleet: {
      tag: 'Nuestra Flota',
      title: 'Vehículos Premium',
      subtitle: 'Elige entre nuestra flota de vehículos modernos y bien mantenidos para cualquier tamaño de grupo.',
      reserve: 'Reservar Este Vehículo',
    },
    testimonials: {
      tag: 'Lo Que Dicen Nuestros Clientes',
      title: 'Reseñas de Clientes',
      subtitle: 'No solo confíes en nuestra palabra. Esto es lo que dicen nuestros clientes satisfechos.',
      verified: 'Cliente Verificado',
      stat1: 'Calificación Promedio',
      stat2: 'Clientes Felices',
      stat3: 'Viajes Completados',
    },
    reservation: {
      tag: 'Reserva Tu Viaje',
      title: 'Hacer una Reservación',
      subtitle: 'Completa el formulario y confirmaremos tu reserva por WhatsApp.',
      transfer: 'Traslado',
      excursion: 'Excursión',
      fullName: 'Nombre Completo',
      email: 'Correo Electrónico',
      whatsapp: 'Número de WhatsApp',
      tripType: 'Tipo de Viaje',
      oneWay: 'Solo Ida',
      roundTrip: 'Ida y Vuelta',
      pickup: 'Recogida (Aeropuerto u Hotel)',
      destination: 'Zona de Destino',
      excursionLabel: 'Selecciona una Excursión',
      excursionPh: 'Elige una excursión...',
      date: 'Fecha',
      time: 'Hora',
      passengers: 'Pasajeros',
      vehicle: 'Vehículo Preferido (Opcional)',
      vehiclePh: 'Seleccionar vehículo (opcional)',
      comments: 'Comentarios (Opcional)',
      submit: 'Confirmar Reservación',
      success: '¡Reserva enviada! Te contactaremos por WhatsApp.',
      error: 'Error al enviar. Intenta nuevamente.',
    },
    footer: {
      about: 'TTS - Transporte Turístico Santos. Servicios de transporte privado y excursiones en República Dominicana.',
      contact: 'Contacto',
      services: 'Servicios',
      followUs: 'Síguenos',
      rights: 'Todos los derechos reservados',
    },
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      excursions: 'Excursions',
      fleet: 'Fleet',
      reserve: 'Book Now',
      admin: 'Admin',
    },
    hero: {
      tag: 'Your Transport in Dominican Republic',
      title1: 'Travel worry-free',
      title2: 'in Dominican Republic',
      subtitle: 'Forget about waiting or negotiating. With our private transportation you get punctuality, safety and comfort guaranteed from the first minute. Airport transfers, hotels and personalized trips with first-class service.',
      pickup: 'Pickup (Airport or Hotel)',
      pickupPh: 'Search airport or hotel...',
      destination: 'Destination',
      destinationPh: 'Search destination...',
      date: 'Date',
      passengers: 'Passengers',
      passengersWord: 'Passengers',
      passengerWord: 'Passenger',
      cta: 'Check Availability',
      stat1: 'Available',
      stat2: 'Licensed Drivers',
      stat3: 'Top Rated',
    },
    services: {
      tag: 'What We Offer',
      title: 'Our Services',
      subtitle: 'From airport pickups to exclusive VIP transfers, we offer comprehensive transportation solutions in the Dominican Republic.',
      seeMore: 'See More',
      items: [
        { title: 'Airport Transfers', desc: 'Reliable pickup and drop-off from Punta Cana International Airport to any hotel or destination.' },
        { title: 'Private Transport', desc: 'Exclusive private trips for couples, families or solo travelers with personalized service.' },
        { title: 'Group Transport', desc: 'Comfortable vehicles for groups of any size, perfect for events and meetings.' },
        { title: 'Excursion Transport', desc: 'Transport to popular excursions like Saona Island, Santo Domingo and more.' },
        { title: 'VIP Service', desc: 'Premium vehicles with luxury amenities for the most demanding travelers.' },
        { title: 'Intercity Transfers', desc: 'Intercity transport in the Dominican Republic with comfort and safety.' },
      ],
    },
    map: {
      tag: 'Service Coverage',
      title: 'Our Destinations',
      subtitle: 'We cover the entire Dominican Republic. Select an airport to view routes and prices.',
      airports: 'Airports',
      destinations: 'Destinations',
    },
    excursions: {
      tag: 'Explore Paradise',
      title: 'Popular Excursions',
      subtitle: 'Discover the most beautiful destinations in the Dominican Republic with our comfortable transportation.',
      reserve: 'Book Excursion',
      viewAll: 'View All Excursions',
      groups: 'All groups',
    },
    fleet: {
      tag: 'Our Fleet',
      title: 'Premium Vehicles',
      subtitle: 'Choose from our fleet of modern and well-maintained vehicles for any group size.',
      reserve: 'Book This Vehicle',
    },
    testimonials: {
      tag: 'What Our Clients Say',
      title: 'Customer Reviews',
      subtitle: "Don't just take our word. Here's what our satisfied customers say.",
      verified: 'Verified Customer',
      stat1: 'Average Rating',
      stat2: 'Happy Customers',
      stat3: 'Completed Trips',
    },
    reservation: {
      tag: 'Book Your Trip',
      title: 'Make a Reservation',
      subtitle: 'Fill the form and we will confirm your reservation via WhatsApp.',
      transfer: 'Transfer',
      excursion: 'Excursion',
      fullName: 'Full Name',
      email: 'Email',
      whatsapp: 'WhatsApp Number',
      tripType: 'Trip Type',
      oneWay: 'One Way',
      roundTrip: 'Round Trip',
      pickup: 'Pickup (Airport or Hotel)',
      destination: 'Destination Zone',
      excursionLabel: 'Select an Excursion',
      excursionPh: 'Choose an excursion...',
      date: 'Date',
      time: 'Time',
      passengers: 'Passengers',
      vehicle: 'Preferred Vehicle (Optional)',
      vehiclePh: 'Select vehicle (optional)',
      comments: 'Comments (Optional)',
      submit: 'Confirm Reservation',
      success: 'Reservation sent! We will contact you via WhatsApp.',
      error: 'Error sending. Please try again.',
    },
    footer: {
      about: 'TTS - Transporte Turístico Santos. Private transportation and excursion services in the Dominican Republic.',
      contact: 'Contact',
      services: 'Services',
      followUs: 'Follow Us',
      rights: 'All rights reserved',
    },
  },
};
